import {
  formatPercentageValue,
  formatNormalNumber,
  createKpiTileItem,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { activeUser, activeUsersPercentageDelta } =
      data.getUserAdoptionScorecard;

    return createKpiTileItem(
      'Active Users',
      formatNormalNumber(activeUser),
      activeUsersPercentageDelta
        ? {
            isPositiveValue: activeUsersPercentageDelta >= 0,
            text: formatPercentageValue(Math.abs(activeUsersPercentageDelta)),
            sideLabel: '',
            showArrow: Number(activeUsersPercentageDelta) !== 0,
          }
        : null
    );
  },
};
